<template>
  <!-- <nav>
    <router-link to="/">Home</router-link> |
    <router-link to="/about">About</router-link>
  </nav> -->

  <!-- 路由视图 -->
  <router-view />
</template>

<script>
import { http } from "@/utils/http.js";
export default {
 
  data() {
    return {
      windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
      windowHeight: document.documentElement.clientHeight, //实时屏幕高度,
    };
  },
  
  watch: {
    windowHeight(val) {
      let that = this;
      // console.log("vue实时屏幕高度：", val, that.windowHeight);
      window.localStorage.setItem('window_height',that.windowHeight)
    },
    windowWidth(val) {
      let that = this;
      // console.log("vue实时屏幕宽度：", val, that.windowHeight);
      window.localStorage.setItem('window_width',that.windowHeight)
    },
  },

  mounted() {
    var that = this;
    // <!--把window.onresize事件挂在到mounted函数上-->
    window.onresize = () => {
      return (() => {
        window.fullHeight = document.documentElement.clientHeight;
        window.fullWidth = document.documentElement.clientWidth;
        that.windowHeight = window.fullHeight; // 高
        that.windowWidth = window.fullWidth; // 宽
      })();
    };

    
  },
};
</script>

<style>

/*修改滚动条样式*/
div::-webkit-scrollbar {
  width: 6px;
  height: 13px;
  /**/
}

div::-webkit-scrollbar-track {
  background: rgb(239, 239, 239);
  border-radius: 2px;
}

div::-webkit-scrollbar-thumb {
  background: #bfbfbf;
  border-radius: 10px;
}

div::-webkit-scrollbar-thumb:hover {
  background: #0466dd;
}

div::-webkit-scrollbar-corner {
  background: #0466dd;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
